<template>
    <div class="main">
        <a-row class="container" :gutter="0">
            <a-col :span="20" style="padding-bottom: 10px;" ref="search">
                <a-row>
                    <a-col span="6">
                        <a-input-search
                                placeholder="请输入关键字"
                                @search="onSearch"
                                enterButton
                        />
                    </a-col>
                    <a-col :span="14" style="margin-left: 20px;">
                        <a-button type="primary" @click="addArticle">添加</a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-divider style="margin: 0;margin-bottom: 10px;"/>
            <a-col :span="24">
                <a-spin tip="加载中..." :spinning="spinning">
                    <div
                            class="demo-infinite-container"
                            v-infinite-scroll="handleInfiniteOnLoad"
                            :infinite-scroll-disabled="busy"
                            :infinite-scroll-distance="10"
                            :style="{height: listsHeight + 'px'}"
                    >
                        <a-list :dataSource="articleLists">
                            <a-list-item slot="renderItem" slot-scope="item, index" >
                                <a-list-item-meta :description="item.deptname"  @click="toAddArticle(item.id)">
                                    <a slot="title">{{item.title}}</a>
                                    <a-avatar slot="avatar" icon="file-text" style="backgroundColor: #1890ff"/>
                                </a-list-item-meta>
                                <div class="desc">{{item.addtime}}<br>{{item.adduser}}</div>
                            </a-list-item>
                            <div v-if="loading && !busy" class="demo-loading-container">
                                <a-spin />
                            </div>
                        </a-list>
                    </div>
                </a-spin>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import FooterToolBar from '../../components/FooterToolBar'
    import ACol from "ant-design-vue/es/grid/Col";
    const nums = 20
    export default {
        name: "ArticleList",
        components:{
            ACol,
            FooterToolBar
        },
        directives: { infiniteScroll },
        data () {
            return {
                userInfo: '',
                page: 1,
                searchValue: '',
                articleLists: [],
                loading: false,
                busy: false,
                spinning: true,
                listsHeight: 0,
                footerBarHeight: 0,
            }
        },
        methods: {
            getList () {
                this.busy = true
                this.$http.post('api/article/lists', { page: this.page, title: this.searchValue})
                    .then((res) => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        if (res.data.state === 200) {
                            if (res.data.data.length > 0) {
                                this.articleLists.push.apply(this.articleLists, res.data.data)
                                if (this.articleLists.length < nums) {
                                    this.busy = true
                                }
                            } else {
                                this.page--
                            }
                        } else {
                            this.page--
                        }
                    })
                    .catch(() => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        this.page--
                    })
            },
            handleInfiniteOnLoad  () {
                this.loading = true
                if (this.articleLists.length < nums) {
                    this.loading = false
                    this.busy = true
                    return
                }
                if (!this.busy) {
                    this.page++
                    this.getList()
                }
            },
            goBack () {
                this.$router.go(-1)
            },
            toAddArticle (_id) {
                this.$router.push({path: '/Main/Draft/AddArticle', query: {id: _id}})
            },
            onSearch (value) {
                if (!this.spinning) {
                    this.searchValue = value
                    this.loading = false
                    this.busy = false
                    this.spinning = true
                    this.articleLists = []
                    this.page = 1
                    this.getList()
                }
            },
            addArticle () {
                this.$router.push('/Main/Draft/AddArticle')
            }
        },
        created() {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted() {
            this.listsHeight = window.innerHeight - 92 - 40 - this.footerBarHeight - this.$refs.search.$el.clientHeight - 11// 92为顶部导航高度 地址栏高度、 40 margin距离、footerBarHeight 56 底部悬浮按钮高度 11 分割线高度
            this.getList()
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 10px;
        padding-right: 20px;
    }
    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 0px 24px;
        overflow-x: hidden;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
    .desc{
        line-height: 22px;
    }
    .ant-list-item-meta{
        cursor: pointer;
    }
</style>
